export const
    INITIAL_STATE = {
        error: null,
        isLoading: false
    };


// WEBPACK FOOTER //
// ./src/reducers/state/InitialData.js